import React from 'react'
import Layout from 'components/Layout'
import About from 'components/About'
import Footer from 'components/Footer'
import Header from 'components/Header'
import Schedule from 'components/Schedule'
import Projects from 'components/Projects'
import IEVersion from 'components/IEVersion'
import { isIE } from 'react-device-detect'
import GlobalStyle from 'styles/global'

const Index = () => {
if (isIE) return (
  <>
    <GlobalStyle />
    <IEVersion />
  </>
)

return (
    <Layout>
      <Header />
      <About />
      <Schedule />
      <Projects />
      <Footer />
    </Layout>
  )
}

export default Index
